<template>
  <!-- 账号管理 -->
  <div
    style="height: calc(100vh - 88px); background-color: #fff"
    class="advanced"
  >
    <p class="titles">
      江苏省检察院用户列表
      <el-button
        type="primary"
        style="height: 36px; display: flex; align-items: center; float: right"
        @click="addProple"
        >新增用户</el-button
      >
    </p>
    <!-- {{ jcy_ID }}{{ name }} -->
    <el-form style="display: flex; align-items: center">
      <el-form-item label="检察院">
        <!-- <el-input v-model="name"></el-input> -->
        <!-- <el-autocomplete
          v-model="name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelectName"
          clearable
        ></el-autocomplete> -->

        <el-cascader
          :show-all-levels="false"
          v-model="name"
          :options="optionsList"
          :props="{ checkStrictly: true }"
          clearable
        ></el-cascader>
      </el-form-item>
      <!-- {{ role }} -->
      <el-form-item label="角色">
        <el-select
          v-model="role"
          placeholder="请选择角色"
          style="width: 100%"
          clearable
        >
          <el-option label="操作员" value="1"></el-option>
          <el-option label="政治部审核员" value="2"></el-option>
          <el-option label="管理员" value="3"></el-option>
        </el-select>
      </el-form-item>
      <!-- {{ search }} -->
      <el-form-item label="">
        <el-input
          placeholder="请输入姓名、登录账号进行搜索"
          v-model="search"
          style="width: 250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          style="height: 36px; display: flex; align-items: center"
          @click="searchList"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="username" label="姓名"> </el-table-column>
      <el-table-column prop="phone" label="登录账号"> </el-table-column>
      <el-table-column prop="jcy_name" label="所属检察院"> </el-table-column>
      <el-table-column prop="address" label="角色">
        <template slot-scope="scope">
          <div>
            <span class="shou">{{ scope.row.role | filtrRole }}</span
            >&nbsp;
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <div>
            <span class="shou">{{
              scope.row.status == 1 ? "正常" : "冻结"
            }}</span
            >&nbsp;
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <div>
            <span class="shou" @click="modify(scope.row)">修改</span>&nbsp;
            <span
              class="shou"
              v-if="scope.row.status"
              @click="dongjie(scope.row, 0)"
              >冻结</span
            >
            <span class="shou" v-else @click="dongjie(scope.row, 1)"
              >解冻
            </span>
            <span class="shou" @click="chongzhi(scope.row)">
              &nbsp;重置密码</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
      >
      </el-pagination>
    </div>
    <!-- //新增用户 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
      class="dialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="flex-direction: column; width: 100%"
      >
        <!-- {{ ruleForm.name }} -->
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <!-- {{ ruleForm.phone }} -->
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" :disabled="disabled"></el-input>
        </el-form-item>
        <!-- {{ ruleForm.pass }} -->
        <el-form-item label="密码" prop="pass" v-if="title !== '修改'">
          <el-input v-model="ruleForm.pass" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="所属检察院" prop="belonging">
          <!-- <el-autocomplete
            v-model="ruleForm.belonging"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择检察院"
            @select="handleSelect"
          ></el-autocomplete> -->

          <el-cascader
            :show-all-levels="false"
            v-model="ruleForm.belonging"
            :options="optionsList"
            @change="handleChange"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
          <!-- <el-select
            v-model="ruleForm.belonging"
            filterable
            @change="selChange"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in restaurants"
              :key="item.id"
              :label="item.value"
              :value="item"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <!-- {{ ruleForm.role }} -->
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="ruleForm.role">
            <el-radio label="1" border>操作员</el-radio>
            <el-radio label="2" border>政治部审核员</el-radio>
            <el-radio label="3" border>管理员</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- {{ ruleForm.state }} -->
        <el-form-item label="状态" prop="state">
          <el-radio-group v-model="ruleForm.state">
            <el-radio label="1" border>正常</el-radio>
            <el-radio label="0" border>冻结</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm" style="height: 36px; padding: 0 20px"
          >取 消</el-button
        >
        <el-button
          type="primary"
          style="height: 36px; padding: 0 20px"
          @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isphone } from "@/filters";
import {
  getAllRegion,
  updateUserInfor,
  updateUserinfo,
  userlist,
  updateStatus,
  updatePassword,
  regionList,
} from "@/api/open";
import { mapGetters } from "vuex";
export default {
  filters: {
    filtrRole(val) {
      if (val == 1) {
        return "操作员";
      } else if (val == 2) {
        return "政治部审核员";
      } else {
        return "管理员";
      }
    },
  },
  data() {
    return {
      optionsList: [],
      clickDIO: 0, //是否点果修改
      info: {}, //单行表格信息
      disabled: false, //是否禁用手机号修改
      title: "新增用户", //
      search: "",
      role: "",
      name: "", //检察院
      jcy_ID: "", //检察院ID
      restaurants: [], //所有检察院
      area: {}, //
      tableData: [],
      userID: "", //当前点击列表的id
      dialogVisible: false, //新增用户
      page: 1, //页数
      pageSize: 15,
      total: 0, //总数
      ruleForm: {
        name: "",
        phone: "", //手机
        pass: "", //密码
        belonging: "", //所属文字
        belongingId: "", //所属id
        role: "", //角色
        state: "", //状态
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: isphone(),
        pass: [
          { required: true, trigger: "blur", message: "密码不能为空" },
          {
            pattern:
              /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
            message: "请输入长度8-16位，包括数字、大写字母、小写字母、特殊字符的密码",
          },
        ],
        belonging: [{ required: true, message: "请选择所属", trigger: "blur" }],
        role: [{ required: true, message: "请选择角色", trigger: "blur" }],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
    };
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    // 获取区域列表
    getAreaList() {
      console.log(this.userInfo);
      let parmas = {
        jcy1: this.userInfo.jcy1,
        jcy2: this.userInfo.jcy2,
        jcy3: this.userInfo.jcy3,
      };
      regionList(parmas).then((res) => {
        if (res.code == 200) {
          this.optionsList = res.data;
          console.log(this.optionsList);
        }
      });
    },
    handleChange(val) {
      console.log(val);
      this.ruleForm.belonging = val[val.length - 1];
      this.area = {
        jcy1: val[0],
        jcy2: val[1] ? val[1] : "",
        jcy3: val[2] ? val[2] : "",
      };
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.userlist();
    },

    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 100 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    /*  handleSelect(item) {
      console.log(item);
      this.ruleForm.belongingId = item.id;
      this.area = {
        jcy1: item.area1,
        jcy2: item.area2,
        jcy3: item.area3,
      }
    }, */
    selChange(val) {
      this.ruleForm.belongingId = val.id;
      this.area = {
        jcy1: val.area1,
        jcy2: val.area2,
        jcy3: val.area3,
      };
    },
    handleSelectName(item) {
      this.jcy_ID = item.id;
    },
    //搜索
    searchList() {
      this.page = 1;
      this.userlist();
    },
    //重置密码
    chongzhi(val) {
      this.$prompt("请输入密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern:
          /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
        inputErrorMessage:
          "请输入长度8-16位，包括数字、大/小写字线、特殊字符的密码",
      }).then(({ value }) => {
        let parmas = {
          user_id: val.id,
          passwordCurrent: this.$md5({ value }.value),
        };
        updatePassword(parmas).then((res) => {
          this.$message.success(res.msg);
        });
      });
    },
    //新增用户
    addProple() {
      this.title = "新增用户";
      this.ruleForm.belonging = ""; //所属文字;
      this.dialogVisible = true;
      if (this.clickDIO == 1) {
        this.$refs.ruleForm.resetFields();
        this.ruleForm.name = "";
        this.ruleForm.phone = ""; //手机
        this.ruleForm.belonging = ""; //所属文字;
        this.ruleForm.belongingId = ""; //所属id
        this.ruleForm.role = ""; //角色
        this.ruleForm.state = ""; //状态
      }
    },
    //关闭弹窗
    handleClose(done) {
      this.resetForm();
      this.disabled = false;
    },
    //确定
    ok() {
      // console.log(this.ruleForm.belonging);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {

          let parmas = {
            id: this.userID,
            username: this.ruleForm.name,
            phone: this.ruleForm.phone,
            jcy_id: this.ruleForm.belonging,
            jcy1: this.area.jcy1,
            jcy2: this.area.jcy2,
            jcy3: this.area.jcy3,
            role: this.ruleForm.role,
            status: this.ruleForm.state,
            password:this.info.password,
            sex: this.info.sex,
            birth: this.info.birth,
            native_place: this.info.native_place,
            introduction: this.info.introduction,
            photo: this.info.photo,
            outlook: this.info.outlook,
            position: this.info.position,
            honor: this.info.honor,
            publicity: this.info.publicity,
            auth: this.info.auth,
            reason: this.info.reason, //驳回原因
          };
          if (this.title == "修改") {
            parmas.password=this.info.password,
            updateUserInfor(parmas).then((res) => {
              if (res.code == 200) {
                this.$message.success("修改成功");
              }
            });
          } else {
             parmas.password=this.$md5(this.ruleForm.pass)
            updateUserinfo(parmas).then((res) => {
              if (res.code == 200) {
                this.$message.success("添加成功");
              }
            });
          }
          this.$refs.ruleForm.resetFields();
          this.title = "新增用户";
          this.userID = "";
          this.disabled = false;
          this.userlist();

          this.dialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
      this.disabled = false;
    },

    // cancel() {
    //   this.$refs.resetForm.$el.click();
    // },
    //获取列表
    userlist() {
      let parmas = {
        user_id: this.userInfo.id,
        page: this.page,
        pageSize: this.pageSize,
        jcy_id: this.name[this.name.length - 1],
        keyword: this.search,
        role: this.role,
      };
      userlist(parmas).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.total;
        }
      });
    },
    //修改
    modify(val) {
      console.log(val);
      this.info = val;
      this.clickDIO = 1;
      this.title = "修改";
      this.ruleForm.name = val.username;
      this.ruleForm.phone = val.phone;
      this.ruleForm.belongingId = val.jcy_id;
      this.ruleForm.belonging = val.jcy_id;
      console.log(this.ruleForm.belonging);
      this.area.jcy1 = val.jcy1;
      this.area.jcy2 = val.jcy2;
      this.area.jcy3 = val.jcy3;
      this.ruleForm.role = String(val.role);
      this.ruleForm.state = String(val.status);
      this.dialogVisible = true;
      this.userID = val.id;
      this.disabled = true;
    },
    //冻结解冻
    dongjie(id, val) {
      let parmas = {
        user_id: id.id,
        status: val,
      };
      updateStatus(parmas).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.userlist();
        }
      });
    },
  },
  mounted() {},
  activated() {
    this.userlist();
    this.getAreaList();
  },
  watch: {
    name(val) {
      if (val == "") {
        this.jcy_ID = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.advanced {
  padding: 10px 20px;
  overflow: scroll;
  .titles {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 25px;
  }
}
/deep/.el-tabs__item.is-active {
  background: #66b1ff;
  color: #ffff !important;
  border: 1px solid #66b1ff;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-radius: 10px 10px 0 0;
  border: none;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-radius: 10px 10px 0 0;
  border: 1px solid rgba(187, 187, 187, 100);
  min-width: 100px;
  text-align: center;
}
/deep/.el-tabs--card > .el-tabs__header {
  border: none;
}
.el-form {
  display: flex;
  align-items: center;
}
.el-form-item {
  display: flex;
  margin-left: 10px;
}
/deep/.el-input__inner {
  height: 36px;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0;
}
/deep/.el-table .el-table__cell {
  padding: 0.5rem 0;
  font-size: 14px;
}
.page {
  position: fixed;
  bottom: 25px;
  right: 20px;
}
.shou {
  cursor: pointer;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
  line-height: 1;
}
/deep/.el-form {
  -webkit-box-align: start;
  -webkit-align-items: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
/deep/.el-radio {
  margin-right: 0px;
}
/deep/.el-radio.is-bordered {
  padding: 8px 10px;
  height: auto;
}
.dialog {
  /deep/.el-form-item {
    width: 100%;
  }
  /deep/.el-form-item__content {
    width: 70%;
  }
}
/deep/.el-autocomplete {
  width: 100%;
}
::v-deep.el-cascader {
  width: 100%;
}
</style>
